import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DswFooterComponent } from '@vi-succ/design-system-web';
import { EnvironmentService } from '../../services';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    standalone: true,
    imports: [DswFooterComponent, TranslateModule],
    host: { class: 'app-footer' },
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterComponent {
    public environmentService = inject(EnvironmentService);
}
